import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { TeamQuery } from 'generated/resources/graphql'

import EditModal from 'modules/teams/components/EditModal'
import type { ITeam } from 'modules/teams/store/models/Team'

import Leaders from './Leaders'
import Members from './Members'

type TeamMembership = NonNullable<NonNullable<TeamQuery['teams']['team']>['memberships']>[number]

interface Props {
  team: ITeam
  readonly: boolean
  memberships: TeamMembership[]
  hasDevJobCatalogTree: boolean
}

const Detail = ({ team, readonly, memberships, hasDevJobCatalogTree }: Props) => {
  const [openEditModal, setOpenEditModal] = React.useState(false)

  return (
    <>
      <Leaders
        team={team}
        readonly={readonly}
        memberships={memberships}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
      />
      <Members
        team={team}
        readonly={readonly}
        memberships={memberships}
        hasDevJobCatalogTree={hasDevJobCatalogTree}
      />
      <Box alignItems="center">
        {openEditModal && <EditModal onClose={() => setOpenEditModal(false)} team={team} />}
      </Box>
    </>
  )
}

export default Detail
